module.exports = __webpack_public_path__ + "static/media/send-msg.9a2dfa2a.svg";